import { HiArrowLeft } from "react-icons/hi";
import { Link } from "react-router-dom";

type FooterBoxActionProps = {
  backUrl?: string;
  backUrlClass?: string;
  backUrlState?: any;
  onBackUrlClick?: (e?: any) => void;
  rightItem?: React.ReactNode;
};

export default function FooterBoxAction({
  backUrl,
  backUrlClass = "btn btn-dark",
  backUrlState,
  onBackUrlClick,
  rightItem = <></>,
}: FooterBoxActionProps) {
  return (
    <div className="mb-3 mt-4 d-flex justify-content-between box-bottom-actions">
      <div>
        {(backUrl || onBackUrlClick) && (
          <Link
            className={backUrlClass}
            to={backUrl ? backUrl : "#"}
            state={backUrlState ? backUrlState : undefined}
            onClick={onBackUrlClick ? onBackUrlClick : undefined}
          >
            <HiArrowLeft /> Back
          </Link>
        )}
      </div>
      {rightItem}
    </div>
  );
}
